export default __webpack_public_path__ + "static/cbd2-f994cdb0097ca0c27ece82c9e356b480.png";